import { Outlet } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

export function AppsRoute() {
  return <Outlet />
}

export function AppsBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.appStore.integrations}>
      <T
        id="Generics.AppsAndIntegrations"
        defaultMessage="Apps & Integrations"
      />
    </Link>
  )
}
